import programs from './programs';
import visitedSites from './visited-sites';
import printData from './print-data';

export default {
  namespaced: true,
  modules: {
    programs,
    visitedSites,
    printData,
  },
};
